export class FraudSuspensionError extends Error {
  constructor(
    message = 'This company has been suspended due to fraudulent activity.'
  ) {
    super(message)
    this.name = 'FraudSuspensionError'
  }
}
